import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Container,
} from '@chakra-ui/react'
import { Helmet } from 'react-helmet'

export const FAQ = () => {
  const faqs = [
    {
      title: 'Why should I create an account?',
      description:
        'When you have an account, your search history is saved automatically. You can then access those searches again through the Searches page on the top menu bar when you are logged in.',
    },
    {
      title: 'Are these songs licensed by Songvisor?',
      description:
        // eslint-disable-next-line quotes
        "No. If you want to use the songs for your projects you will have to handle licensing them yourself. To obtain a music license, you need to obtain permission from a legal entity that represents the artist's work. This can be the artist themselves, a publisher, record label, performing rights organization or music licensing company.",
    },
    {
      title: 'Can I get songs that are DMCA free?',
      description:
        'You can currently start your description with something like "A DMCA free song" and you should be given some results. Always check the licensing of the song to make sure you are using it properly. There is no planned release for an in-depth feature yet for better DMCA free results but plans for it is in the works. ',
    },
    {
      title: 'One of the songs in the list is not actually a real song',
      description:
        'AI can sometimes be confidently incorrect and this means that results that are given may not be real and something completely made up. You can double check with the external link button to see if it gives you an actual song',
    },
    {
      title: 'I am getting errors when trying to search for songs',
      description:
        'At the moment data usage is capped while more users start using the app. It will currently work as a first come, first serve basis so you may run into errors towards the end of each month.',
    },
  ]

  return (
    <Box w='100%' p={4} pb={8}>
      <Helmet>
        <title>FAQ | Songvisor</title>
      </Helmet>
      <Container maxW='3xl'>
        <Accordion>
          {faqs.map((faq) => (
            <AccordionItem key={faq.title}>
              <h2>
                <AccordionButton>
                  <Box as='span' flex='1' textAlign='left'>
                    {faq.title}
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>{faq.description}</AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Container>
    </Box>
  )
}
